import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ListTypes } from './types';
import {
    getDepartmentsTypeService,
    getInquiryTypeService,
    getPermissionService,
    getPublicImageService,
    getRolesService,
    getTransactionsTypesListsService,
    getWorkflowConfigurationService
} from '../../services/services';

const initialState: ListTypes = {
    loading: false,
    error: "",
    departmentTypes: [],
    transactionTypes: [],
    inquiryTypes: [],
    roles: [],
    workflow: [],
    publicImage: null,
    logo: null,
    permissions: [],
};

export const departmentTypesThunk = createAsyncThunk("listTypes/departmentTypesThunk", async () => {
    try {
        const { data } = await getDepartmentsTypeService();
        return { data };
    } catch (error: any) {
        console.log("error--", error);
        throw new Error(error);
    }
});

export const transactionTypesThunk = createAsyncThunk("listTypes/transactionTypesThunk", async () => {
    try {
        const { data } = await getTransactionsTypesListsService();
        return { data };
    } catch (error: any) {
        console.log("error--", error);
        throw new Error(error);
    }
});

export const getRolesThunk = createAsyncThunk("listTypes/getRolesThunk", async () => {
    try {
        const { data } = await getRolesService();
        return { data }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
});

export const getWorkflowConfigThunk = createAsyncThunk("listTypes/getWorkflowConfigThunk", async () => {
    try {
        const { data } = await getWorkflowConfigurationService();
        return { data }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})

export const getInquiryTypesThunk = createAsyncThunk("listTypes/getInquiryTypesThunk", async () => {
    try {
        const payload = {
            parameters: {}
        }
        const { data } = await getInquiryTypeService(payload);
        return { data }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})

export const getPublicImageThunk = createAsyncThunk("listTypesSlice/getPublicImageThunk", async (arg: string) => {
    try {
        const { data } = await getPublicImageService(arg);
        return { data }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})

export const getPermissionsThunk = createAsyncThunk("listTypesSlice/getPermissionsThunk", async () => {
    try {
        const { data } = await getPermissionService();
        return { data }
    } catch (error: any) {
        console.log("error--", error)
        throw new Error(error)
    }
})

export const listTypesSlice = createSlice({
    name: 'listTypes',
    initialState,
    reducers: {
        errorReducer: (state) => {
            state.error = ""
        },
        cleaState: (state) => {
            return initialState
        }
    },
    extraReducers(builder) {
        builder
            .addCase(departmentTypesThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(departmentTypesThunk.fulfilled, (state, action) => {
                state.departmentTypes = action.payload.data
                state.loading = false
                state.error = ""
            })
            .addCase(departmentTypesThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
            .addCase(transactionTypesThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(transactionTypesThunk.fulfilled, (state, action) => {
                state.transactionTypes = action.payload.data
                state.loading = false
                state.error = ""
            })
            .addCase(transactionTypesThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
            .addCase(getInquiryTypesThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(getInquiryTypesThunk.fulfilled, (state, action) => {
                state.inquiryTypes = action.payload.data.types
                state.loading = false
                state.error = ""
            })
            .addCase(getInquiryTypesThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
            .addCase(getRolesThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(getRolesThunk.fulfilled, (state, action) => {
                state.roles = action.payload.data
                state.loading = false
                state.error = ""
            })
            .addCase(getRolesThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
            .addCase(getWorkflowConfigThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(getWorkflowConfigThunk.fulfilled, (state, action) => {
                state.workflow = action.payload.data
                state.loading = false
                state.error = ""
            })
            .addCase(getWorkflowConfigThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
            .addCase(getPublicImageThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(getPublicImageThunk.fulfilled, (state, action) => {
                state.publicImage = action.payload.data
                state.loading = false
                state.error = ""
            })
            .addCase(getPublicImageThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
            .addCase(getPermissionsThunk.pending, (state, action) => {
                state.loading = true
            })
            .addCase(getPermissionsThunk.fulfilled, (state, action) => {
                state.permissions = action.payload.data
                state.loading = false
                state.error = ""
            })
            .addCase(getPermissionsThunk.rejected, (state, action) => {
                state.error = action.error.message!
                state.loading = false
            })
    },
});

export const listTypesActions = listTypesSlice.actions;
export default listTypesSlice.reducer;